export const sleepTime = (waitTime) =>
    // eslint-disable-next-line no-promise-executor-return
    new Promise((resolve) => setTimeout(resolve, waitTime * 1000))
